"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectLogDirective = injectLogDirective;

var _logTrack = require("../logTrack");

var _common = require("../common");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var log = function log() {
  var event_type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'page';
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var el = arguments.length > 2 ? arguments[2] : undefined;

  // 在page事件中，page_name和name相同
  if (event_type === 'page' || event_type === 'show') {
    config.name = config.name || config.page_name;
  } // 获取 trackName 事件名称


  var trackName = (0, _common.findTrackName)(config);

  if (trackName === undefined) {
    trackName = event_type;
  }

  _logTrack.LogTrack.track(_objectSpread({
    event_type: event_type,
    $el: el
  }, config), trackName);
};

var findLogTag = function findLogTag(el) {
  // 筛选出 v-fastclick 和 v-log
  var element = (0, _common.findParentEl)(el, function (_el) {
    // igc_click 绑定过的不用再发
    if (_el) {
      if (_el.dataset.igc_click) {
        // 之所以筛选出，是因为不返回true，会继续向上查找。但这里找到有 click 绑定的就无需再找了，后面把他排除掉。
        return true;
      } else {
        if (_el.dataset.igc_log || _el.tagName === 'A' || _el.tagName === 'INPUT' // || _el.tagName === 'IMG'
        || _el.tagName === 'VIDEO' || _el.tagName === 'BUTTON') {
          return true;
        }
      }
    }
  }); // 再排除掉上面两个中的一个无用的

  if (element && !element.dataset.igc_click) {
    return element;
  }
};
/**
 * 注入 v-log 指令
 * @param {Vue} vue Vue 对象
 * @param {Object=} options LogTrack.config 所依赖的配置项
 */


function injectLogDirective(vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (vue && vue.directive) {
    vue.prototype.$log = log;
    document.body.addEventListener('click', function (ev) {
      var el = findLogTag(ev.target);

      if (el) {
        var logData = el.dataset.igc_log;

        try {
          logData = JSON.parse(logData);
        } catch (e) {
          logData = undefined;
        }

        var arg = '';

        try {
          arg = el.dataset.arg;
        } catch (e) {
          arg = '';
        }

        if (arg === 'click') {
          log('click', logData, el);
        }
      }
    }, false);

    var directiveHandler = function directiveHandler(el, bind) {
      var arg = bind.arg,
          value = bind.value,
          modifiers = bind.modifiers; // 加入 modifiers 的逻辑，在 value 里通过 __ev_track_name 这个 key 传递 trackName

      var arr = Object.keys(modifiers).filter(function (e) {
        return e.startsWith('ev__');
      });

      if (arr.length === 1) {
        value.__ev_track_name = arr[0].slice(4);
      }

      if (!(0, _common.isNil)(value)) {
        el.dataset.igc_log = JSON.stringify(value);
        el.dataset.arg = arg;
      }

      if (arg === 'page' || arg === 'show') {
        // page 直接调用
        log(arg, value, {});
      }
    }; // 点击统计 指令


    vue.directive('log', {
      bind: directiveHandler,
      update: directiveHandler,
      unbind: function unbind(el) {
        // 移除数据
        delete el.dataset.igc_log;
      }
    });
  }
}